/* KAMOK_ACCESSIBILITY_CORE_20260726 */
window.KamOkA11y = (() => {
  const productCache = new Map();
  const nativeLanguage = 'lt';

  const copy = {
    lt: {
      nav: 'Pagrindinė prekybos centro navigacija',
      mobileNav: 'Mobilus meniu',
      home: 'Pradžia',
      openMenu: 'Atidaryti meniu',
      closeMenu: 'Uždaryti meniu',
      vat: 'Kaina su PVM',
      image: 'prekės nuotrauka',
      unitLong: (unit) => `Pardavimo vienetas: 1 ${unit}. Įvedus kiekį 1, į krepšelį bus pridėtas 1 ${unit}.`,
      unitShort: (unit) => `Kiekis 1 = 1 ${unit}`,
      quantity: (title, unit) => `Prekės ${title} kiekis, ${unit}`,
      increase: (title, unit) => `Padidinti prekės ${title} kiekį vienu ${unit}`,
      decrease: (title, unit) => `Sumažinti prekės ${title} kiekį vienu ${unit}`,
    },
    en: {
      nav: 'Main shopping centre navigation',
      mobileNav: 'Mobile menu',
      home: 'Home',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      vat: 'VAT included',
      image: 'product image',
      unitLong: (unit) => `Sale unit: 1 ${unit}. Entering quantity 1 adds 1 ${unit} to the cart.`,
      unitShort: (unit) => `Quantity 1 = 1 ${unit}`,
      quantity: (title, unit) => `Quantity of ${title}, in ${unit}`,
      increase: (title, unit) => `Increase quantity of ${title} by one ${unit}`,
      decrease: (title, unit) => `Decrease quantity of ${title} by one ${unit}`,
    },
    pl: {
      nav: 'Główna nawigacja centrum handlowego',
      mobileNav: 'Menu mobilne',
      home: 'Strona główna',
      openMenu: 'Otwórz menu',
      closeMenu: 'Zamknij menu',
      vat: 'Cena zawiera VAT',
      image: 'zdjęcie produktu',
      unitLong: (unit) => `Jednostka sprzedaży: 1 ${unit}. Wpisanie ilości 1 dodaje do koszyka 1 ${unit}.`,
      unitShort: (unit) => `Ilość 1 = 1 ${unit}`,
      quantity: (title, unit) => `Ilość produktu ${title}, w ${unit}`,
      increase: (title, unit) => `Zwiększ ilość produktu ${title} o jeden ${unit}`,
      decrease: (title, unit) => `Zmniejsz ilość produktu ${title} o jeden ${unit}`,
    },
  };

  const units = {
    lt: {
      m: 'metras', cm: 'centimetras', mm: 'milimetras', kg: 'kilogramas', g: 'gramas',
      l: 'litras', ml: 'mililitras', vnt: 'vienetas', pcs: 'vienetas', piece: 'vienetas',
      rulonas: 'rulonas', roll: 'rulonas', pakuote: 'pakuotė', package: 'pakuotė',
      komplektas: 'komplektas', set: 'komplektas', deže: 'dėžė', deze: 'dėžė', box: 'dėžė',
      pora: 'pora', pair: 'pora', por: 'pora', pak: 'pakuotė', kompl: 'komplektas',
    },
    en: {
      m: 'metre', cm: 'centimetre', mm: 'millimetre', kg: 'kilogram', g: 'gram',
      l: 'litre', ml: 'millilitre', vnt: 'item', pcs: 'item', piece: 'item',
      rulonas: 'roll', roll: 'roll', pakuote: 'package', package: 'package',
      komplektas: 'set', set: 'set', deže: 'box', deze: 'box', box: 'box',
      pora: 'pair', pair: 'pair', por: 'pair', pak: 'package', kompl: 'set',
    },
    pl: {
      m: 'metr', cm: 'centymetr', mm: 'milimetr', kg: 'kilogram', g: 'gram',
      l: 'litr', ml: 'mililitr', vnt: 'sztuka', pcs: 'sztuka', piece: 'sztuka',
      rulonas: 'rolka', roll: 'rolka', pakuote: 'opakowanie', package: 'opakowanie',
      komplektas: 'zestaw', set: 'zestaw', deže: 'pudełko', deze: 'pudełko', box: 'pudełko',
      pora: 'para', pair: 'para', por: 'para', pak: 'opakowanie', kompl: 'zestaw',
    },
  };

  const locale = () => {
    const value = (document.documentElement.lang || nativeLanguage).split('-')[0].toLowerCase();
    return copy[value] ? value : nativeLanguage;
  };
  const text = () => copy[locale()];

  function normalizeUnit(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^sale_unit:/, '')
      .replace(/^ksl_unit:/, '')
      .replace(/[.\s]/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function unitWord(value) {
    const normalized = normalizeUnit(value);
    return units[locale()][normalized] || normalized || units[locale()].vnt;
  }

  function parseTags(tags) {
    if (Array.isArray(tags)) return tags.map(String);
    if (typeof tags === 'string') return tags.split(',').map((tag) => tag.trim()).filter(Boolean);
    return [];
  }

  function unitFromTags(tags) {
    const list = parseTags(tags);
    const preferred = list.find((tag) => /^sale_unit:/i.test(tag));
    if (preferred) return preferred.replace(/^sale_unit:/i, '').trim();
    const fallback = list.find((tag) => /^ksl_unit:/i.test(tag));
    return fallback ? fallback.replace(/^ksl_unit:/i, '').trim() : '';
  }

  function unitFromPrice(root) {
    const explicit = root?.querySelector?.('.price[data-kamok-sale-unit]')?.dataset.kamokSaleUnit;
    if (explicit) return explicit;

    const value = root?.querySelector?.('.unit-price')?.textContent?.toLowerCase() || '';
    for (const candidate of ['kg', 'cm', 'mm', 'ml', 'm', 'l']) {
      const expression = new RegExp(`(?:/|\\b)${candidate}(?:\\b|$)`);
      if (expression.test(value)) return candidate;
    }
    return '';
  }

  function safeProductPath(url) {
    const raw = String(url || '');
    const direct = raw.match(/^(?:https?:\/\/[^/]+)?(?:\/(?:en|pl))?(\/products\/[^/?#]+)/i);
    if (direct) return direct[1];
    try {
      const parsed = new URL(raw, document.baseURI || location.href);
      const match = parsed.pathname.match(/^(?:\/(?:en|pl))?(\/products\/[^/?#]+)/i);
      return match ? match[1] : '';
    } catch {
      return '';
    }
  }

  async function getProduct(url) {
    const path = safeProductPath(url);
    if (!path) return null;
    if (productCache.has(path)) return productCache.get(path);

    const promise = fetch(`${path}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productCache.set(path, promise);
    return promise;
  }

  function productTitle(scope) {
    return (
      scope?.querySelector?.('.product__title h1')?.textContent?.trim() ||
      scope?.querySelector?.('.cart-item__name')?.textContent?.trim() ||
      scope?.querySelector?.('.card__heading a:not([aria-hidden="true"])')?.textContent?.trim() ||
      scope?.querySelector?.('.card__heading a')?.textContent?.trim() ||
      ''
    );
  }

  function productUrl(scope) {
    return (
      scope?.dataset?.url ||
      scope?.querySelector?.('.cart-item__name[href]')?.href ||
      scope?.querySelector?.('.card__heading a[href]')?.href ||
      ''
    );
  }

  return { nativeLanguage, copy, units, locale, text, normalizeUnit, unitWord, parseTags, unitFromTags, unitFromPrice, safeProductPath, getProduct, productTitle, productUrl };
})();
